module.exports = __webpack_public_path__ + "img/motor.f8a176cc.jpg";